import _capitalize from "lodash/capitalize";
import { useContext, useRef } from 'react';
import classnames from 'classnames';
import { Button } from "../../Button/Button/Button";
import { Popup } from "../../Popup/Popup/Popup";
import { Text } from "../../Text/Text/Text";
import { ThemeContext } from "../../../context/theme.context";
import styles from "./OfferBanner.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var OfferBanner = function OfferBanner(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$wrapperClassName = _ref.wrapperClassName,
    wrapperClassName = _ref$wrapperClassName === void 0 ? '' : _ref$wrapperClassName,
    _ref$buttonClassName = _ref.buttonClassName,
    buttonClassName = _ref$buttonClassName === void 0 ? '' : _ref$buttonClassName,
    text = _ref.text,
    popup = _ref.popup,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? false : _ref$sticky;
  var theme = useContext(ThemeContext);
  var popupComponent = useRef(null);
  var togglePopup = function togglePopup() {
    var _popupComponent$curre;
    popupComponent === null || popupComponent === void 0 ? void 0 : (_popupComponent$curre = popupComponent.current) === null || _popupComponent$curre === void 0 ? void 0 : _popupComponent$curre.togglePopup();
  };
  return /*#__PURE__*/_jsx("div", {
    className: classnames(className, {
      [styles.sticky]: sticky,
      [styles.darkBackground]: theme === 'darkBackground'
    }),
    children: (text || popup) && /*#__PURE__*/_jsxs("div", {
      className: classnames(wrapperClassName, styles.wrapper, styles["wrapper".concat(_capitalize(align))]),
      children: [(text === null || text === void 0 ? void 0 : text.text) && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          textElement: "span",
          typog: text.typog,
          className: text.className,
          richText: true,
          children: text.text
        }), /*#__PURE__*/_jsx("span", {
          children: " "
        })]
      }), (popup === null || popup === void 0 ? void 0 : popup.title) && /*#__PURE__*/_jsx(Popup, {
        ref: popupComponent,
        handle: /*#__PURE__*/_jsx(Button, {
          className: classnames(styles.button, buttonClassName),
          type: "no-style",
          onClick: togglePopup,
          "aria-haspopup": true,
          children: /*#__PURE__*/_jsx(Text, {
            className: classnames(styles.text, popup.className),
            typog: text ? text.typog : 'bodycopy',
            textElement: "span",
            children: "".concat(popup.title)
          })
        }),
        children: /*#__PURE__*/_jsx(Text, {
          className: styles.content,
          typog: "captionSmall",
          richText: true,
          children: popup.content
        })
      })]
    })
  });
};